/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMvListResponseDto } from '../../models/backend-mv-list-response-dto';

export interface ListMvsAdminMvsGet$Params {}

export function listMvsAdminMvsGet(
  http: HttpClient,
  rootUrl: string,
  params?: ListMvsAdminMvsGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMvListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, listMvsAdminMvsGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMvListResponseDto>;
    }),
  );
}

listMvsAdminMvsGet.PATH = '/admin/mvs';
